import { useDispatch } from "react-redux";
import React, { useCallback } from "react";
import {
  DetailedFinancialStatementForm,
  DetailedFinancialStatementFormValues,
} from "components/MultiSaleReports/ManyReportsForm/DetailedFinancialStatementReports/Form";
import { ReportJobAction } from "actions/reportJob";
import { Form, Formik } from "formik";
import { validationSchema } from "components/MultiSaleReports/ManyReportsForm/DetailedFinancialStatementReports";
import { Grid } from "@material-ui/core";
import { ModalActions } from "components/MultiSaleReports/ManyReportsForm/BulkReportFormCommon";

interface FormValues extends DetailedFinancialStatementFormValues {
  businessIds: string[];
  report: "DetailedFinancialStatementReport";
}

interface BusinessDetailedFinancialStatementFormProps {
  businessIds: string[];
  onClose: () => void;
  reportSlug: "DetailedFinancialStatementReport";
}

export function BusinessDetailedFinancialStatementForm(
  props: BusinessDetailedFinancialStatementFormProps,
) {
  const { businessIds, onClose, reportSlug } = props;
  const dispatch = useDispatch();

  const onSubmit = useCallback(
    (values: FormValues) => {
      dispatch(ReportJobAction.createBulk(values));
      onClose();
    },
    [dispatch, onClose],
  );

  const initialValues: FormValues = {
    businessIds,
    report: reportSlug,
    startDate: null,
    endDate: null,
    showStockDetails: false,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <Grid container spacing={2}>
          <DetailedFinancialStatementForm />
        </Grid>
        <ModalActions onClose={onClose} />
      </Form>
    </Formik>
  );
}
